import { Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTariffManagementTariffLineItem extends Layout {
    checkboxChargeRegardlessFlag: Checkbox;
    checkboxRateEitherDirection: Checkbox;
    horizontalspacer1: HorizontalSpacer;
    labelRateCalculation: Label;
    labelRateQualification: Label;
    panelRateCalculation: Panel;
    panelRateQualification: Panel;
    sourceTariffLineItem: DataSource;
    textboxAveragePalletWeight: Textbox;
    textboxCalcFactor2: Textbox;
    textboxCalcFactor: Textbox;
    textboxCarrierScac: Textbox;
    textboxCompareOptionCode: Textbox;
    textboxConsRegName: Textbox;
    textboxConveyanceTypeCode: Textbox;
    textboxCopyToTariff: Textbox;
    textboxCubicUnits: Textbox;
    textboxCurrency: Textbox;
    textboxEffectiveTimestamp: Textbox;
    textboxExpireTimestamp: Textbox;
    textboxFreightValue: Textbox;
    textboxGlaUid: Textbox;
    textboxHandlingUnits: Textbox;
    textboxLinearUnits: Textbox;
    textboxMaximumCharge: Textbox;
    textboxMethod: Textbox;
    textboxMiles: Textbox;
    textboxMinimumCharge: Textbox;
    textboxNmfc: Textbox;
    textboxPieces: Textbox;
    textboxPriority: Textbox;
    textboxProductSku: Textbox;
    textboxQualFactor1: Textbox;
    textboxQualFactor2: Textbox;
    textboxRate: Textbox;
    textboxRateNote: Textbox;
    textboxServiceTypeCode: Textbox;
    textboxShipRegName: Textbox;
    textboxSpots: Textbox;
    textboxWeight: Textbox;
}
